// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"0c731253","100":"226f35fe","125":"8df5b615","130":"dfcba4f6","166":"b7daaced","210":"9dccc7cf","256":"5723c7d8","453":"0c049b65","462":"a16a04ad","617":"8a552925","808":"24877f55"}[chunkId] + ".chunk.js";
};